import React from "react";
import GENRES, { MAX_ARTIST_GENRES } from "../../../utils/genres";

/**
 * Multi-select genres with removable chips and a dropdown to add more (max MAX_ARTIST_GENRES).
 */
function GenreMultiSelect({
  value,
  onChange,
  disabled = false,
  selectClassName = "settings-input",
}) {
  const selected = Array.isArray(value) ? value : [];
  const available = GENRES.filter((g) => !selected.includes(g));
  const atCap = selected.length >= MAX_ARTIST_GENRES;

  const handleAdd = (e) => {
    const g = e.target.value;
    if (!g || selected.includes(g) || selected.length >= MAX_ARTIST_GENRES) {
      return;
    }
    onChange([...selected, g]);
    e.target.value = "";
  };

  const handleRemove = (g) => {
    onChange(selected.filter((x) => x !== g));
  };

  return (
    <div className="genre-multiselect">
      <div className="genre-multiselect-chips" aria-live="polite">
        {selected.map((g) => (
          <span key={g} className="genre-multiselect-chip">
            {g}
            <button
              type="button"
              className="genre-multiselect-chip-remove"
              onClick={() => handleRemove(g)}
              disabled={disabled}
              aria-label={`Remove ${g}`}
            >
              ×
            </button>
          </span>
        ))}
      </div>
      <select
        className={selectClassName}
        value=""
        onChange={handleAdd}
        disabled={disabled || atCap || available.length === 0}
        aria-label="Add a genre"
      >
        <option value="">
          {atCap
            ? `Maximum ${MAX_ARTIST_GENRES} genres`
            : "Add a genre..."}
        </option>
        {available.map((g) => (
          <option key={g} value={g}>
            {g}
          </option>
        ))}
      </select>
      <p className="input-hint genre-multiselect-hint">
        Select 1–{MAX_ARTIST_GENRES} genres from the list.
      </p>
    </div>
  );
}

export default GenreMultiSelect;
